import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";

function DataExporter(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const stringify=(ob)=>{
    if(props.plain) {
      return ob;
    } else {
      return JSON.stringify(ob);
    }
  };

  return (
    <div className="dn">
      <textarea value={props.rawValue?(props.exportIndex?compStore.data[props.exportIndex]:compStore.data):stringify(toJS(props.exportIndex?compStore.data[props.exportIndex]:compStore.data))} name={compStore.options.inputName} readOnly={true} />
    </div>
  )
};

DataExporter.defaultProps = {
  plain:false,
  exportIndex:""
};

DataExporter.propTypes = {
  plain: PropTypes.bool,
  exportIndex: PropTypes.string
};

export default observer(DataExporter);
